// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "status-26uot";
var _3 = "waiting-zujxD";
var _4 = "rejected-1D7m6";
var _5 = "processing-uGgds";
var _6 = "icon-2PFf2";
export { _1 as "__esModule", _2 as "status", _3 as "waiting", _4 as "rejected", _5 as "processing", _6 as "icon" }
export default { "__esModule": _1, "status": _2, "waiting": _3, "rejected": _4, "processing": _5, "icon": _6 }
